import React, { useState, useEffect, useRef } from 'react';
import './StickyFooter.css';
import axios from "axios";
import { Link, useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const StickyFooter = ({ schoolId = null }) => {

  const baseUrl = schoolId ? `/${schoolId}` : "";
  const { school_slug } = useParams();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(true);
  const [footerInView, setFooterInView] = useState(false);
  const observerRef = useRef(null);

  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios.get(
      `${baseAPIUrl}api/general_settings/get_general_settings/${finalSchoolSlug}`
    )
      .then(res => {
        if (res.data.status === 1) {
          setInfo(res.data.data.settings);
        }
      })
      .catch(err => console.error("CONTACT API ERROR:", err))
      .finally(() => setLoading(false));
  }, [school_slug]);

  useEffect(() => {
    const footerElement = document.querySelector('footer'); // change if needed

    if (!footerElement) return;

    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        setFooterInView(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    observerRef.current.observe(footerElement);

    return () => {
      if (observerRef.current && footerElement) {
        observerRef.current.unobserve(footerElement);
      }
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible || footerInView) return null;

  return (
    <div className="sticky-footer slide-up">
      <button className="close-btn" onClick={handleClose}>
        <i className="fas fa-times"></i>
      </button>

      <div className="sticky-footer-content">
        <span className="sticky-footer-text">
          Let's secure your child's future
        </span>

        <div className="arrow-animation">➤</div>

        <div className="sticky-footer-contacts">
          <a href={`tel:${info?.phone}`} className="sticky-footer-contact-item pulse-phone">
            <i className="fas fa-phone-alt sticky-footer-icon"></i>
            <span className="sticky-footer-contact-text">{info?.phone}</span>
          </a>

          <a href={`mailto:${info?.email}`} className="sticky-footer-contact-item pulse-email">
            <i className="fas fa-envelope sticky-footer-icon"></i>
            <span className="sticky-footer-contact-text">{info?.email}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default StickyFooter;
